import React, { useState } from 'react';
import {
  makeStyles,
  Button,
  StylesProviderV4,
  jssPreset,
  ThemeProviderV4,
  StyledEngineProvider,
  ThemeProvider,
} from '~/lib/bn-material-ui';
import { muiTheme, conversions, useMeasurement, generateClassName } from '~/utility/BinSentry-ui-utility';
import { create } from 'jss';
import UnmonitoredBanner from './banners/unmonitored';
import ConsumptionRate from './consumption-rate/consumption-rate';
import ManufacturersCapacity from './manufacturers-capacity/manufacturers-capacity';
import ManualBinLevel from '../../parcels/manual-bin-level/manual-bin-level';

const useStyles = makeStyles((theme) => {
  return {
    box: {
      padding: '1rem',
      border: `1px solid ${theme.palette.gray[40]}`,
    },
    layout: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    marginBottom: {
      marginBottom: '1rem',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  };
});

const jss = create({ ...jssPreset() });

export default function UnmonitoredSetup({ href, bin }) {
  const [showConsumption, setShowConsumption] = useState(false);
  const [showCapacity, setShowCapacity] = useState(false);
  const [showManualInventory, setShowManualInventory] = useState(false);
  const styles = useStyles();
  const orderAmountMeasurement = useMeasurement({ name: 'orderAmount' });

  let capacityButtonText = 'Set Manufacturer\'s Capacity';
  const listedCapacity = bin.properties.listedCapacity;
  if (listedCapacity > 0) {
    capacityButtonText = `Manufacturer's Capacity: ${
      conversions.kilogramsToOrderAmountPref(listedCapacity, orderAmountMeasurement.unit)
    } ${orderAmountMeasurement.unit}`;
  }

  let consumptionRateText = 'Set Consumption Rate';
  const consumptionRate = bin.properties.consumptionRate;
  if (consumptionRate > 0) {
    consumptionRateText = `Consumption Rate: ${
      orderAmountMeasurement.convert({
        volume: consumptionRate,
        bulkDensity: bin.properties.bulkDensity,
      })
    } ${orderAmountMeasurement.unit}/day`;
  }

  return (
    <>
      <div className={styles.header}>
        <h3>Level History</h3>
      </div>
      <UnmonitoredBanner />
      <div className={`${styles.layout} ${styles.box}`}>
        <span className={styles.marginBottom}>
          Manufacturer’s capacity, consumption rate, and a manual inventory are required to begin
          generating bin levels for standard bins.
        </span>
        <Button variant='text' onClick={() => setShowCapacity(true)}>
          {capacityButtonText}
        </Button>
        <Button variant='text' onClick={() => setShowConsumption(true)}>
          {consumptionRateText}
        </Button>
      </div>
      <StyledEngineProvider generateClassName={generateClassName} injectFirst>
        <StylesProviderV4 generateClassName={generateClassName} jss={jss}>
          <ThemeProvider theme={muiTheme}>
            <ThemeProviderV4 theme={muiTheme}>
              <ConsumptionRate
                href={href}
                oldRate={bin.properties.consumptionRate}
                bulkDensity={bin.properties.bulkDensity}
                handleClose={() => setShowConsumption(false)}
                show={showConsumption}
              />
              <ManufacturersCapacity
                href={href}
                handleClose={() => setShowCapacity(false)}
                oldCapacity={bin.properties.listedCapacity}
                show={showCapacity}
              />
              <ManualBinLevel
                href={href}
                show={showManualInventory}
                handleClose={() => setShowManualInventory(false)}
              />
            </ThemeProviderV4>
          </ThemeProvider>
        </StylesProviderV4>
      </StyledEngineProvider>
    </>
  );
}
